// extracted by mini-css-extract-plugin
module.exports =  {"button":"_0bc5e8de02--button--RKZvy","icon":"_0bc5e8de02--icon--M4N1r"};